import React, { useState, useEffect } from "react"
import { useRouter } from "next/router"
import PropTypes from "prop-types"

import LazyLoad from "react-lazyload"
import { useSelector } from "react-redux"
import { useScrollPosition } from "react-use-scroll-position"
import Banner from "@/components/rc-banner"
import SmsPhone from "@/components/rc-sms-phone"
import styles from "./index.scss"

import HistorySold from "./modules/history-sold"
import OwnerStory from "./modules/owner-story"
import SellFooter from "./modules/sell-footer"

import { orderSellCheck, getSellBanner } from "./service"
import { $cookie, sessionstorage } from "$utils"

const Sell = ({ bannerdata }) => {
  const city = useSelector(store => store.city)
  const router = useRouter()
  const [showSellFooter, setShowSellFooter] = useState(false)
  // 首屏不展示，高度>500时展示
  const { y } = useScrollPosition() || { y: 0 }
  const [phone, setPhone] = useState(
    $cookie.get("rrc_login_phone") || sessionstorage.get("intentPhone") || ""
  )
  useEffect(() => {
    setShowSellFooter(y > 500)
  }, [y])

  const onSuccess = (mobile_number) => {
    router.push({
      pathname: "/sell/addinfo",
      query: { mobile_number },
      to: "/sell/addinfo"
    })
  }

  const noteJsx = (
    <p className="txt">
      阅读并同意
      <a href="https://sta.renrenche.com/legal/terms.html" target="_blank">
        《用户服务协议》
      </a>
      、
      <a href="https://sta.renrenche.com/legal/privacy.html" target="_blank">
        《隐私政策》
      </a>
      提交并注册为用户。提交即视为同意人人车电联您提供服务
    </p>
  )

  return (
    <>
      <div className={styles["r-sales"]}>
        {/* 高价卖车 */}
        <div className="sell-submit-box-wrapper">
          <div className="sell-submit-box">
            <h2 className="title-main">高价卖车</h2>
            <h3 className="title-sub">免费提供车辆定价参考与评估服务</h3>
            <SmsPhone
              noSms
              wrapClassName="sell-submit"
              phoneClickGa="SalesModule_input_phone_top_click"
              submitBtnTxt="免费高价卖车"
              submitSources="预约卖车-PC-卖车页-1"
              submitParams={{
                city: city.city,
                sell_source: "pc端",
                phone_source: city.fr,
                device: "pc",
                source: "0",
                product: "预约卖车",
                sub_product: "预约卖车"
              }}
              submitBtnGa="SalesModule_btn_top_saleofvehicles_click"
              submitFunc={orderSellCheck}
              onSuccess={onSuccess}
              noteJsx={noteJsx}
              noteChecked
              phone={phone}
              onPhoneChange={(_phone) => {
                setPhone(_phone)
              }}
            />
          </div>
        </div>

        <Banner bannerdata={bannerdata} />

        <div className="r-sales__content">
          {/* 高价卖车服务 */}
          <div className="r-sales__content-service">
            <h1 className="title">高价卖车服务</h1>
            <div className="title-line" />
            <ul className="list clearfix">
              <li className="list-item">
                <div className="icon dtnq" />
                <p className="title">当天拿钱</p>
                <p className="desc">
                  验车现场
                  <br />
                  最高可收全部车款
                </p>
              </li>
              <li className="list-item">
                <div className="icon gjmc" />
                <p className="title">高价卖车</p>
                <p className="desc">
                  平台推荐买家
                  <br />
                  获取更高报价
                </p>
              </li>
              <li className="list-item">
                <div className="icon sssx" />
                <p className="title">省时省心</p>
                <p className="desc">
                  交易手续代办
                  <br />
                  车辆过户不操心
                </p>
              </li>
            </ul>
          </div>

          {/* 卖车流程 */}
          <div className="r-sales__content-process">
            <h1 className="title">高价卖车流程</h1>
            <div className="title-line" />
            <ul className="list">
              <li className="list-item">
                <div className="icon zxksyy" />
                <p className="title">在线快速预约</p>
              </li>
              <li className="list-item dot" />
              <li className="list-item">
                <div className="icon mfsmpg" />
                <p className="title">免费上门评估</p>
              </li>
              <li className="list-item dot" />
              <li className="list-item">
                <div className="icon dtsnck" />
                <p className="title">当天速拿车款</p>
              </li>
              <li className="list-item dot" />
              <li className="list-item">
                <div className="icon sxdbgh" />
                <p className="title">省心代办过户</p>
              </li>
            </ul>
          </div>

          {/* 历史售出 */}

          <LazyLoad>
            <HistorySold />
          </LazyLoad>

          {/* 车主故事 */}

          <LazyLoad>
            <OwnerStory />
          </LazyLoad>

          {/* 人人问答 */}
          <LazyLoad>
            <div className="r-sales__content-guide">
              <h3 className="title">- 人人问答 -</h3>
              <div className="r-sales__content-guide-container clearfix">
                <div className="child">
                  <div className="item">
                    <span className="item-title">Q1 人人车怎么帮我卖车？</span>
                    <p className="item-content">
                      人人车是专业二手车交易服务平台，每天有百万买家在这里选车，我们只将您的爱车卖给真实买家，在把您的爱车卖个公道价格的同时，完全杜绝了经销商、4S店对您的骚扰。
                    </p>
                  </div>

                  <div className="item">
                    <span className="item-title"> Q3 卖车流程是什么？ </span>
                    <p className="item-content">
                      1、在此页面填写车辆信息，或拨打400-039-6051联系我们。
                      <br />
                      2、卖车顾问与您约定好时间地点后，评估师将上门对车辆进行初步评估，搜集车辆信息且对车辆进行拍照，评估师将依据人人车大数据提供一个建议售价。
                      <br />
                      3、对于符合人人车上架标准的车辆，人人车将车辆信息及初步车况发布至人人车平台，并予以多方推广，为您寻找买家。
                      <br />
                      4、带有购买意向的买家约见看车。
                      <br />
                      5、买家将与您签署《二手车买卖合同》，您须配合进行车辆复检，复检通过后方可办理车辆过户。
                    </p>
                  </div>
                </div>

                <div className="child">
                  <div className="item">
                    <span className="item-title">
                      Q2 通过人人车出售车辆需要什么费用？
                    </span>
                    <p className="item-content">
                      在人人车平台，车辆卖家从车辆信息发布到卖车意向确定整个过程，我们不会收取任何费用。卖家可放心在平台发布车辆信息，匹配合适买家。
                    </p>
                  </div>

                  <div className="item">
                    <span className="item-title">
                      Q4 在人人车转让需要准备什么？
                    </span>
                    <div className="item-content">
                      <p>
                        需要先在网站提供您的联系电话，车辆品牌、型号等基本信息。待服务人员联系您后，在约定时间内准备好
                      </p>
                      <div className="left">
                        <p>1、身份证</p>
                        <p>2、行驶证</p>
                        <p>3、车辆登记证</p>
                        <p>4、车辆钥匙</p>
                      </div>
                      <div className="right">
                        <p>5、车示标（环保标、检字标、交强险标）</p>
                        <p>6、交强险单</p>
                        <p>7、购置税本及购置税发票</p>
                        <p>8、购车发票/最近一次过户发票</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </LazyLoad>
          {showSellFooter && (
            <SellFooter
              onPhoneChange={(_phone) => {
                setPhone(_phone)
              }}
              phone={phone}
            />
          )}
        </div>
      </div>
    </>
  )
}

export default Sell

Sell.propTypes = {
  bannerdata: PropTypes.any
}

Sell.defaultProps = {
  bannerdata: {}
}

Sell.getInitialProps = async () => {
  try {
    const data = await getSellBanner()
    const bannerdata = data.data
    return {
      bannerdata: bannerdata
    }
  } catch (error) {
    console.log(error)
    return {
      bannerdata: {
        banner: "https://img1.rrcimg.com/202209201104_pc_banner.jpg",
        banner_background_color: "#eaf0ff"
      }
    }
  }
}
